module.exports = __webpack_public_path__ + "static/img/tx.c6b33ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img2/tx.png
// module id = zZ5i
// module chunks = 3